<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'

import { TEST_IDS_CREATE } from '@/_testIds/testIdsCreate'
import ButtonSecondary from '@/components/common/ui/buttons/ButtonSecondary.vue'
import FormSelect from '@/components/common/ui/inputs/FormSelect.vue'
import InputGrid from '@/components/common/ui/inputs/InputGrid.vue'
import TextInput from '@/components/common/ui/inputs/TextInput.vue'
import CreatePersonLinkedOrganizations from '@/components/editRelationGroup/sections/CreatePersonLinkedOrganizations.vue'
import SectionMetaData from '@/components/editRelationGroup/sections/SectionMetaData.vue'
import { useBackendConstantsStore } from '@/stores/backendConstantsStore'
import { translationFunctionDefault } from '@/utilities/translations'

interface CreatePersonFormShortProps {
  onShowAllFields(): void
}

defineProps<CreatePersonFormShortProps>()

const tfDefault = translationFunctionDefault()

const backendConstantsStore = useBackendConstantsStore()
const { fetchSalutationList } = backendConstantsStore
const { salutationOptionList } = storeToRefs(backendConstantsStore)

onMounted(async () => {
  await fetchSalutationList()
})
</script>

<template>
  <div class="flex flex-col items-center">
    <div class="w-full px-8">
      <InputGrid :columns="2">
        <div class="col-span-2">
          <FormSelect
            :data-testid="TEST_IDS_CREATE.createPersonForm.title"
            :label="tfDefault('editPerson.generalDataAcademicTitle')"
            name="salutation"
            on-white-bg
            :options="[salutationOptionList]"
            :placeholder="tfDefault('editRelationGroup.selectPlaceholder')"
            searchable
          />
        </div>
        <TextInput
          :data-testid="TEST_IDS_CREATE.createPersonForm.firstName"
          in-create-context
          :label="tfDefault('editPerson.generalDataFirstName')"
          name="first_name"
          required
        />
        <TextInput
          :data-testid="TEST_IDS_CREATE.createPersonForm.lastName"
          in-create-context
          :label="tfDefault('editPerson.generalDataLastName')"
          name="last_name"
          required
        />
      </InputGrid>
    </div>
    <SectionMetaData />
    <CreatePersonLinkedOrganizations name="links" />
    <ButtonSecondary
      class="mt-5"
      :data-testid="TEST_IDS_CREATE.createPersonForm.showAllFields"
      :label="tfDefault('createRelation.showAllFields')"
      small
      @click="onShowAllFields"
    />
  </div>
</template>
